import { render, staticRenderFns } from "./SkillStatements.vue?vue&type=template&id=cb6d6604&scoped=true"
import script from "./SkillStatements.vue?vue&type=script&lang=js"
export * from "./SkillStatements.vue?vue&type=script&lang=js"
import style0 from "./SkillStatements.vue?vue&type=style&index=0&id=cb6d6604&prod&scoped=true&lang=scss"
import style1 from "./SkillStatements.vue?vue&type=style&index=1&id=cb6d6604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d6604",
  null
  
)

export default component.exports